<template>
    <div class="new-lesson">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">完成情况</p>
            <p class="preview"
               @click="preview()">作业预览</p>
        </div>
        <div class="main">
            <div class="item">
                <p class="title"> 未完成<span>{{is_not_correct_user.length}}</span>人 </p>
                <div class="con">
                    <span v-for="(item,index) in is_not_correct_user"
                          :key="index">{{item}}</span>
                </div>
            </div>
            <div class="item">
                <p class="title"> 已完成<span>{{is_correct_user.length}}</span>人 </p>
                <div class="con">
                    <table v-if="is_correct_user.length">
                        <tbody>
                            <tr>
                                <th>姓名</th>
                                <th>完成时间</th>
                            </tr>
                            <tr v-for="(item,index) in is_correct_user"
                                :key="index">
                                <td>{{item.username}}</td>
                                <td>{{item.test_date}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            //学科
            sid: this.$route.params.sid,
            //试卷ID
            paper_id: this.$route.params.paper_id,
            //班级id
            unit_class_id: this.$route.params.unit_class_id,
            //未完成学生
            is_not_correct_user: [],
            //已完成学生
            is_correct_user: []
        }
    },
    created () {
        this.getDoneInfo()
    },
    methods: {
        preview () {
            if (this.sid == 21) {
                this.$router.push(`/preview/task/${this.sid}/${this.paper_id}/2023winternew`)
            } else if (this.sid == 51) {
                this.$router.push(`/activity/2023winter/chinesePreview/51/${this.paper_id}`)
            }
        },
        getDoneInfo () {
            let url = API_URL_HD_API + "/winter2023/tea/paper_detail";
            let data = {
                sid: this.sid,
                paper_id: this.paper_id,
                unit_class_id: this.unit_class_id,
            }
            this.$http.post(url, data).then(res => {
                if (res.data.response == 'ok') {
                    //已完成
                    this.is_correct_user = res.data.data.is_correct_user
                    //未完成
                    this.is_not_correct_user = res.data.data.is_not_correct_user
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.new-lesson {
    min-height: 100vh;
    background-color: #f5f9ff;
    padding-top: 96px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
.item {
    padding: 24px / $ppr;
    .title {
        font-size: 24px / $ppr;
        color: #3c7cfb;
        font-weight: bold;
        line-height: 74px / $ppr;
        span {
            margin: 0 8px / $ppr;
        }
    }
    .con {
        margin: 0 auto 34px / $ppr;
        border-radius: 24px / $ppr;
        background: #fff;
        span {
            width: 25%;
            display: inline-block;
            text-align: center;
            line-height: 80px / $ppr;
            height: 80px / $ppr;
            overflow: hidden;
        }
        table {
            width: 100%;
            tr {
                &:nth-child(2n) {
                    background: #fafafa;
                }
            }
            th {
                font-weight: bold;
            }
            th,
            td {
                padding: 30px / $ppr 0;
                width: 50%;
                text-align: center;
                &:first-child {
                    text-align: left;
                    padding-left: 70px / $ppr;
                }
            }
        }
    }
}
</style>